module.exports = __webpack_public_path__ + "static/media/navLogo.4dc8a4b3.svg";